import { Injectable } from '@angular/core';
import { io, Socket } from 'socket.io-client';
import { Observable,Subscription } from 'rxjs';
import $ from 'jquery';
import Swal from 'sweetalert2';
import { ApiService } from './services/api.service';
import { CommonEventService } from './services/common-event.service';
@Injectable({
  providedIn: 'root'
})
export class WebSocketService {
  public socket:any = Socket;
  public isSocketConnected = false;
  jobId: string | null = null;

  message: string = '';
  receivedMessages:any = [];
  messageSubscription:any = Subscription;

  datacheckLevel1 :any = [1,2];
  datacheckLevel2 : any = [1,2];
  datacheckLevel3 : any = [1];
  dataFnCalled : boolean = false;
  errorFound = false;

  constructor(public apiService:ApiService,public commonService:CommonEventService) { 
    
      if(!this.isSocketConnected){
        this.initializeSocket();
      }
   }

   
  // ngOnInit() {
  //   this.initializeSocket();
  // }

  initializeSocket(): void {
    if(!this.isSocketConnected){
      this.socket = io(this.apiService.REST_API_SERVER, {
        transports: ['websocket'],
        upgrade: false,
        reconnection: true,
        reconnectionAttempts: 5,
        reconnectionDelay: 1000,
        reconnectionDelayMax: 5000,
        timeout: 20000
      });
      this.socket.on('connect', () => {
        this.isSocketConnected = true;
        this.updateTaskStatus('','connection', 'WebSocket Connected');
        console.log('Socket connected:', this.socket.id);
      });

      this.socket.on('disconnect', () => {
        this.isSocketConnected = false;
        console.log('disconnect',true);
        this.updateTaskStatus('','connection', 'WebSocket Disconnected');
      });

      this.socket.on('job_connected', (data:any) => {
        this.isSocketConnected = false;
        this.updateTaskStatus('','connection', 'Job Connected');
      });

      this.socket.on('task_update', (data: any) => {
        if(data.status == 'error'){
          this.commonService.loadingHide();
          this.commonService.alertCall('Error!', 'There was an error processing the file. Please reach out to the Sierra support Team for assistance.');
          return false;
        }
        if(data.task == 'unzip_identify' && data.status == 'complete' && data.data && !this.commonService.commonMainObj.unzip_identify){
          this.commonService.commonMainObj.fileUploadedData = data.data;
          this.commonService.commonMainObj.fileUploadedData.filename = this.commonService.commonMainObj.fileUploadedData.originalFilename
          this.commonService.commonMainObj.unzip_identify = true;
          this.datacheckLevel1.splice(0, 1)
        }
        if(data.task == 'validate_layers' && data.status == 'complete' && data.data && !this.commonService.commonMainObj.validate_layers){
          if(data.data.multipleFoldersDetected){
            this.commonService.commonMainObj.fileUploadedData.multipleFoldersDetected = data.data.multipleFoldersDetected
          }else{
            delete this.commonService.commonMainObj.fileUploadedData.multipleFoldersDetected
          }
          this.commonService.commonMainObj.fileUploadedData.fabErrors = data.data.fabErrors
          this.commonService.commonMainObj.fileUploadedData.fabWarnings = data.data.fabWarnings
          this.commonService.commonMainObj.fileUploadedData.assemblyErrors = data.data.assemblyErrors
          this.commonService.commonMainObj.fileUploadedData.assemblyWarnings = data.data.assemblyWarnings
          this.commonService.commonMainObj.fileUploadedData.infoMessages = data.data.infoMessages
          this.commonService.commonMainObj.fileUploadedData['dimension-x'] = data.data['dimension-x']
          this.commonService.commonMainObj.fileUploadedData['dimension-y'] = data.data['dimension-y']
          this.commonService.commonMainObj.fileUploadedData['dimensionx'] = data.data['dimensionx']
          this.commonService.commonMainObj.fileUploadedData['dimensiony'] = data.data['dimensiony']
          this.commonService.commonMainObj.fileUploadedData.burriedVias = data.data.burriedVias
          this.commonService.commonMainObj.fileUploadedData.uploadedBOM = data.data.uploadedBOM
          this.commonService.commonMainObj.fileUploadedData.setId = data.data.setId
          this.commonService.commonMainObj.fileUploadedData.version = data.data.version
          this.commonService.commonMainObj.fileUploadedData.noOfCuLay = data.data.noOfCuLay
          this.commonService.commonMainObj.validate_layers = true;
          this.datacheckLevel1.splice(0, 1)
        }
        if(data.task == 'fabrication_drawing' && data.status == 'complete' && data.data && !this.commonService.commonMainObj.fabrication_drawing){
          this.commonService.commonMainObj.fileUploadedData.boardParam = data.data.boardParam;
          this.commonService.commonMainObj.fabrication_drawing = true;
          this.datacheckLevel2.splice(0, 1)
        }
        if(data.task == 'drill_data' && data.status == 'complete' && data.data && !this.commonService.commonMainObj.drill_data){
          this.commonService.commonMainObj.fileUploadedData.noOfDrills = data.data.noOfDrills
          this.commonService.commonMainObj.fileUploadedData.drillInfo = data.data.drillInfo
          this.commonService.commonMainObj.fileUploadedData.drillReport = data.data.drillReport
          // this.commonService.commonMainObj['mapped_via_in_pad'] = data.data.drillInfo.viaInPad
          this.commonService.commonMainObj.drill_data = true;
          this.datacheckLevel2.splice(0, 1)
        }
        if(data.task == 'render_images' && data.status == 'complete' && data.data && !this.commonService.commonMainObj.render_images){
          this.commonService.commonMainObj.fileUploadedData.topImageWidth = data.data.topImageWidth
          this.commonService.commonMainObj.fileUploadedData.botImageWidth = data.data.botImageWidth
          this.commonService.commonMainObj.fileUploadedData.topImageHeight = data.data.topImageHeight
          this.commonService.commonMainObj.fileUploadedData.botImageHeight = data.data.botImageHeight
          this.commonService.commonMainObj.fileUploadedData.topImage = data.data.topImage
          this.commonService.commonMainObj.fileUploadedData.botImage = data.data.botImage
          this.commonService.commonMainObj.render_images = true;
          this.datacheckLevel3.splice(0, 1)
        }
        if(data.task == 'assembly_drawing' && data.status == 'complete' && data.data){
          this.commonService.commonMainObj.fileUploadedData.boardParam_assembly = data.data.boardParam_assembly;
        }
        if(data.task == 'pcb_additional_fast' && data.status == 'complete' && data.data && !this.commonService.commonMainObj.pcb_additional_fast){
          this.commonService.commonMainObj.fileUploadedData.boardParam_fast_pcb = data.data.boardParam_fast_pcb
          this.commonService.commonMainObj.pcb_additional_fast = true;
        }
        if(data.task == 'fabrication_drawing_additional' && data.status == 'complete' && data.data && !this.commonService.commonMainObj.fabrication_drawing_additional){
          this.commonService.commonMainObj.fileUploadedData.boardParam_additional_pcb = data.data.boardParam_additional_pcb
          this.commonService.commonMainObj.fabrication_drawing_additional = true;
        }
        if(this.datacheckLevel1.length == 0 && this.dataFnCalled == false){
          this.dataFnCalled = true;
          this.getUploadedData(this.commonService.commonMainObj.fileUploadedData)
        }
        if(data.task == 'save_metadata' && data.status == 'complete' && !this.commonService.commonMainObj.save_metadata){
          this.commonService.commonMainObj.saveMataDataCheck = true;
        }
        if(data.task == 'lamination_calculation' && data.status == 'complete' && data.data.lamination_cycle && !this.commonService.commonMainObj.lamination_calculation){
          this.commonService.commonMainObj.laminationCycleObj['fems_number_of_laminations'] = data.data.lamination_cycle.fems_number_of_laminations
          this.commonService.commonMainObj.laminationCycleObj['fems_controlled_depth_drilling'] = data.data.lamination_cycle.fems_controlled_depth_drilling
          this.commonService.commonMainObj.laminationCycleObj['fems_mechanical_drill_cycles'] = data.data.lamination_cycle.fems_mechanical_drill_cycles
          this.commonService.commonMainObj.lamination_calculation_check = true;
        }
        // if(this.datacheckLevel1.length == 0 && this.datacheckLevel2.length == 0 && this.datacheckLevel3.length == 0){
        //   this.disconnect();
        // }
      });
    
    }
  }




   // Method to emit an event to the server
  // sendMessage(event: string, data: any): void {
  //   this.socket.emit(event, data);
  // }

  // Method to listen for events from the server
  onEvent(event: string): Observable<any> {
    return new Observable(observer => {
      this.socket.on(event, (data: any) => {
        observer.next(data);
      });
    });
  }

  // Disconnect the socket (e.g., on component destroy)
  disconnect(): void {
    this.socket.disconnect();
  }
  
  sendMessage(formData:any): void {
    // if (this.message.trim()) {
    //   this.socketService.sendMessage('message', this.message);
    //   this.message = ''; // Clear input
    // }
    this.datacheckLevel1 = [1,2];
    this.datacheckLevel2 = [1,2];
    this.datacheckLevel3 = [1]
    this.dataFnCalled = false;
    this.commonService.commonMainObj.unzip_identify = false;
    this.commonService.commonMainObj.validate_layers = false;
    this.commonService.commonMainObj.fabrication_drawing = false;
    this.commonService.commonMainObj.drill_data = false;
    this.commonService.commonMainObj.render_images = false;
    this.commonService.commonMainObj.fabrication_drawing_additional = false;
    this.commonService.commonMainObj.pcb_additional_fast = false;
    this.commonService.commonMainObj.saveMataDataCheck = false;
    this.commonService.commonMainObj.lamination_calculation_check = false;
    this.commonService.commonMainObj.multipleODBFilesDataProceedIstDetails = {};
    this.apiService.webSocketAPI(formData,this.socket.id).subscribe((response)=>{
      if (!response || !response.job_id || !response.token) {
        throw new Error('Missing job_id or token in response');
      }
      this.jobId = response.job_id;
      this.updateTaskStatus('upload', 'complete', 'File uploaded successfully');
      this.connectWebSocket(response.job_id, response.token);
    },error=>{
        this.commonService.loadingHide();
    })
  }

  
  connectWebSocket(jobId: string, token: string): void {
    console.log(`Connecting job with ID: ${jobId} and token: ${token}`);

    if (!this.isSocketConnected) {
      console.log('Socket not connected. Attempting to reconnect...');
      this.socket.connect();
    }

    let cleanToken = token;
    if (typeof token === 'string' && token.startsWith("b'") && token.endsWith("'")) {
      cleanToken = token.slice(2, -1);
      console.log('Cleaned token from byte string format');
    }

    this.socket.emit('connect_job', {
      job_id: jobId,
      token: cleanToken,
    });
  }

  updateTaskStatus(taskId:any, status:any, data:any): void {
    // console.log(data);
  }

  
  getUploadedData(data:any){
      this.commonService.commonMainObj.fileFormatError = false;
      if(this.commonService.commonMainObj.moreFileFormatError){
        this.commonService.commonMainObj.uploadedFilesData= '';
      }
      this.commonService.commonMainObj.moreFileFormatError = false;
        this.commonService.commonMainObj.listOfAllFiles = [];
        this.commonService.commonMainObj.fabErrWarArray=[];
        this.commonService.sessionPortalLoad();
        setTimeout(()=>{
          if(data.error){
            this.commonService.alertCall('Error!!',data.description);
            //this.uploadshow = true;
            this.commonService.goBack();
          }else{
            //console.log("fileUploadedData",data);
            // var dupObj = JSON.stringify(data);
            this.apiService.apiMainObj.fileUploadedData = data;
            this.commonService.commonMainObj.fileUploadedData = data;
            this.commonService.commonMainObj.bomFileIncluded = data.assemblyErrors && data.assemblyErrors.FV_BM_E01?true:false;
            this.commonService.commonMainObj.uploadedFileName = data.filename;
            this.commonService.commonMainObj.s3FileName = data.s3_file;
            this.commonService.commonMainObj.source = data.source;
            this.commonService.commonMainObj.odbFilesAvailable = 'No';
            this.commonService.commonMainObj.gerbersProvided = 'No';
            if(data.directoryList && data.directoryList.length > 0){
              for(let i=0; i < data.directoryList.length; i++){
                if(data.directoryList[i].type && data.directoryList[i].type != ''){
                  this.commonService.commonMainObj.odbFilesAvailable = data.directoryList[i].type == 'ODB' ? 'Yes' : 'No';
                  this.commonService.commonMainObj.gerbersProvided = data.directoryList[i].type == 'GERBER' ? 'Yes' : 'No';
                  break;
                }
              }
            }
            this.errorFound = false;
            this.commonService.loadingHide();
            data['fileErrors'] = [];
            if(Object.keys(data.fabErrors).length > 0){
              for(var errIndx in data.fabErrors){
                this.commonService.commonMainObj.fabErrWarArray.push(data.fabErrors[errIndx])
                if(errIndx != 'FV_GE_E00'){
                  data['fileErrors'].push(data.fabErrors[errIndx]);
                }
                if(data.fabErrors['FV_GE_E00'] && data.fabErrors['FV_GE_E02']){
                  this.errorE00Fn(data,errIndx);
                  break;
                }else if(errIndx == 'FV_GE_E00'){
                  this.errorE00Fn(data,errIndx);
                }else if(errIndx == 'FV_GE_E01'){
                  this.commonService.commonMainObj.fileFormatError = true;
                  this.commonService.commonMainObj.moreFileFormatError = true;
                  Swal.fire({
                    title: "Error!!",
                    text:data.fabErrors[errIndx]['error'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Re-Upload Files',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if (result.isConfirmed) {
                        $("#checkFileUpload").trigger('click');
                        $("#checkFileUpload").val('');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }else if(errIndx == 'FV_GE_E02'){
                  // OFP-3971
                  this.errE02Fn(data,data.fabErrors['FV_GE_E02'].error);
                }else if(errIndx == 'FV_SE_E03'){
                  Swal.fire({
                    title: "Error!!",
                    text:data.fabErrors[errIndx]['error'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: 'Ok',
                  }).then((result:any) => {
                    if (result.isConfirmed) {
                      this.commonService.goBack();
                    } else if (result.isDismissed) {
                      // this.commonService.goBack();
                    }
                  })
                }
              }
            }
            if(data.fabWarnings && Object.keys(data.fabWarnings).length > 0){
              data['fileWarnings'] = [];
              for(var errIndx in data.fabWarnings){
                this.commonService.commonMainObj.fabErrWarArray.push(data.fabWarnings[errIndx])
                if(!this.errorFound && errIndx != 'FV_GE_E00'){
                  data['fileWarnings'].push(data.fabWarnings[errIndx]);
                }
                if(!this.errorFound && errIndx == 'FV_GE_E00'){
                  // this.confirmAlert('Warning!!',data.fabWarnings[errIndx]['warning'],'Ok','Cancel')
                  Swal.fire({
                    title: "Warning!!",
                    text:data.fabWarnings[errIndx]['warning'],
                    showConfirmButton: true,
                    showDenyButton: false,
                    showCancelButton: true,
                    confirmButtonText: 'Ok',
                    cancelButtonText: 'Cancel'
                  }).then((result:any) => {
                    if(result.isConfirmed) {
                      //$("#checkFileUpload").trigger('click');
                    } else if (result.isDismissed) {
                      this.commonService.goBack();
                    }
                  })
                }
                //console.log("TestfabErrWarArray",this.commonService.commonMainObj.fabErrWarArray);
                this.commonService.commonMainObj.boardOutlineProvided = data.fabWarnings.FV_BO_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.layerOrderProvided = data.fabWarnings.FV_CL_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.drillFileProvided = data.fabWarnings.FV_DR_W00 ? 'No' : 'Yes';
                this.commonService.commonMainObj.fabDrawingProvided = data.fabWarnings.FV_FD_W00 ? 'No' : 'Yes';

              }
            }else{
              this.commonService.commonMainObj.boardOutlineProvided = 'Yes';
              this.commonService.commonMainObj.layerOrderProvided = 'Yes';
              this.commonService.commonMainObj.drillFileProvided = 'Yes';
              this.commonService.commonMainObj.fabDrawingProvided = 'Yes';
            }
            this.commonService.commonMainObj.assembllyErrWarArray = [];
            if(data.assemblyWarnings && Object.keys(data.assemblyWarnings).length > 0){
              this.commonService.commonMainObj.assemblyDrawingProvided = data.assemblyWarnings.FV_AD_W00?'No':'Yes';
              data['fileWarnings'] = data.fileWarnings ? data['fileWarnings'] : [];
              for(var errIndx in data.assemblyWarnings){
                this.commonService.commonMainObj.assembllyErrWarArray.push(data.assemblyWarnings[errIndx]);
                data.fileWarnings.push(data.assemblyWarnings[errIndx]);
                if(errIndx == 'FV_XY_W00'){
                  this.commonService.commonMainObj.xyFilePresent = 'No';
                }
                // if(errIndx == 'FV_AD_W00'){
                //   data.assemblyWarnings[errIndx]['ist_details']['issueID'] = 315;
                // }else if(errIndx == 'FV_XY_W00'){
                //   data.assemblyWarnings[errIndx]['ist_details']['issueID'] = 130;
                // }else if(errIndx == 'FV_XY_W01'){
                //   data.assemblyWarnings[errIndx]['ist_details']['issueID'] = 316;
                // }else if(errIndx == 'FV_SP_W00'){
                //   data.assemblyWarnings[errIndx]['ist_details']['issueID'] = 317;
                // }else if(errIndx == 'FV_SP_W01'){
                //   data.assemblyWarnings[errIndx]['ist_details']['issueID'] = 318;
                // }else if(errIndx == 'FV_SP_W02'){
                //   data.assemblyWarnings[errIndx]['ist_details']['issueID'] = 319;
                // }else if(errIndx == 'FV_SP_W03'){
                //   data.assemblyWarnings[errIndx]['ist_details']['issueID'] = 320;
                // }
                // this.commonService.commonMainObj.assembllyErrWarArray.push(data.assemblyWarnings[errIndx]);
              }
            }else{
              this.commonService.commonMainObj.assemblyDrawingProvided = 'Yes';
            }
            //console.log("assembllyErrWarArray",this.commonService.commonMainObj.assembllyErrWarArray);
            if(!this.commonService.commonMainObj.fileUploadedData.uploadedBOM || Object.keys(this.commonService.commonMainObj.fileUploadedData.uploadedBOM).length == 0){
              this.commonService.commonMainObj.fileUploadedData.uploadedBOM = '';
            }
            this.commonService.commonMainObj.validationCheck = false;
            this.commonService.commonMainObj.uploadedFilesData = data;
            this.commonService.commonMainObj.designPackageName = this.commonService.commonMainObj.uploadedFilesData.filename ? this.commonService.commonMainObj.uploadedFilesData.filename.split('.').slice(0, -1).join('.'):'';
            // console.log("data CHECK", this.commonService.commonMainObj.uploadedFilesData);
            this.commonService.commonMainObj.uploadedFilesData.partNumber = this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_part_number?this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_part_number:'';
            this.commonService.commonMainObj.uploadedFilesData.partRevision = this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_revision?this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_revision:'';
            if(this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_part_number){
              this.commonService.commonMainObj.partNumHide = true;
              this.commonService.commonMainObj.partNumberImg = "Extracted_icon";
              //$('#'+this.commonService.commonMainObj.partNumHide).show();
            }else{
              this.commonService.commonMainObj.partNumHide = false;
            }
            if(this.commonService.commonMainObj.uploadedFilesData.boardParam.pcb_revision){
              this.commonService.commonMainObj.partRevHide= true;
              this.commonService.commonMainObj.partRevisionImg = "Extracted_icon";
            }else{
              this.commonService.commonMainObj.partRevHide= false;
            }
            if(data.directoryList){
              for(let i=0; i < data.directoryList.length; i++){
                for(let k=0; k < data.directoryList[i].files.length; k++){
                  //this.listOfAllFiles['files'] = {};
                  // data.directoryList[i].files[k]['mainFileType'] = data.directoryList[i].type;
                  this.commonService.commonMainObj.listOfAllFiles.push(data.directoryList[i].files[k]);
                }
                //this.listOfAllFiles['mainFileType'] = data.directoryList[i].type;
              }
            }
            if((this.commonService.commonMainObj.uploadedFilesData.partNumber+'').length > 40 && (this.commonService.commonMainObj.uploadedFilesData.partRevision+'').length > 10){
              this.commonService.commonMainObj.uploadedFilesData.partNumber = this.commonService.commonMainObj.uploadedFilesData.partNumber.slice(0, 40);
              this.commonService.commonMainObj.uploadedFilesData.partRevision = this.commonService.commonMainObj.uploadedFilesData.partRevision.slice(0, 10);
              Swal.fire({
                title: "Alert",
                text:"Extracted Part number(max 40 characters) and Revision(max 10 characters) exceeded the limits. Extra characters will be truncated.",
                showConfirmButton: true,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: 'Ok',
              })
            }else{
              if(this.commonService.commonMainObj.uploadedFilesData.partNumber && (this.commonService.commonMainObj.uploadedFilesData.partNumber+'').length > 40){
                this.commonService.commonMainObj.uploadedFilesData.partNumber = this.commonService.commonMainObj.uploadedFilesData.partNumber.slice(0, 40);
                Swal.fire({
                  title: "Alert",
                  text:"Extracted Part number exceeded character limits (max 40 characters). Extra characters will be truncated.",
                  showConfirmButton: true,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                })
              }
              if(this.commonService.commonMainObj.uploadedFilesData.partRevision && (this.commonService.commonMainObj.uploadedFilesData.partRevision+'').length > 10){
                this.commonService.commonMainObj.uploadedFilesData.partRevision = this.commonService.commonMainObj.uploadedFilesData.partRevision.slice(0, 10);
                Swal.fire({
                  title: "Alert",
                  text:"Extracted Revision exceeded character limits (max 10 characters). Extra characters will be truncated.",
                  showConfirmButton: true,
                  showDenyButton: false,
                  showCancelButton: false,
                  confirmButtonText: 'Ok',
                })
              }
            }
            // console.log("listOFFILES", this.commonService.commonMainObj.listOfAllFiles);
          }
          //window.scrollTo(0, 0);
          $('html, body').animate({scrollTop:$('#scrollTop').position().top}, '');
          this.apiService.createDataForActivityEntry();
            setTimeout(()=>{
              var uploadFileDetailsData={
                "issuesDisplayed":this.commonService.commonMainObj.uploadedFilesData.fileWarnings
              }
              this.apiService.updateDetailsToDashboard(this.commonService.commonMainObj.fileId,uploadFileDetailsData,'UploadFileDetailsPage').subscribe((resDatas)=>{
              })
            },5000);
        },300)
    }

    errorE00Fn(data:any,errIndx:any){
      // this.fileFormatError = true;
      // this.moreFileFormatError = true;
      Swal.fire({
        title: "Warning!!",
        text:data.fabErrors[errIndx]['error'],
        showConfirmButton: true,
        showDenyButton: false,
        showCancelButton: true,
        confirmButtonText: 'Ok',
        cancelButtonText: 'Cancel'
      }).then((result:any) => {
        if(result.isConfirmed) {
          //$("#checkFileUpload").trigger('click');
          if(data.fabErrors['FV_GE_E00'] && data.fabErrors['FV_GE_E02']){
            this.multiFileIstData(data.fabErrors['FV_GE_E00'])
            this.errE02Fn(data,data.fabErrors['FV_GE_E02'].error);
          }
        } else if (result.isDismissed) {
          this.commonService.goBack();
        }
      })
    }

    errE02Fn(data:any,error:any){
      let message= '';
      this.errorFound = true;
      this.commonService.commonMainObj.moreFileFormatError = true;
      
      
      let selectedKey: string | null = null;
      // OFP-3971 added below line and commented the following
      message = error;
      // message = `
      //   <ul style="padding-left:0">
      //     <li style="list-style-type:none;font-weight:bold;">
      //       More than one ${data.multipleFoldersDetected.type} file is uploaded. Please select any one of the file to proceed.
      //     </li>
      //     <li style="visibility:hidden;">fdnsfg</li>
      // `;

      Object.keys(data.multipleFoldersDetected.folders).forEach((key) => {
        const item = data.multipleFoldersDetected.folders[key];
        message += `
          <li style="list-style-type:none;text-align:left;margin-bottom:10px;" class="multiErrList">
            <input type="radio" id="radioSelect_${key}" value="${key}" name="multiFileErrors" />
            <label for="radioSelect_${key}">${item.displayPath}</label>
          </li>
        `;
      });

      message += `
        <li style="list-style-type:none;font-weight:bold;text-align:left;padding-top:20px;color:#0d6efd;">
          NOTE: Files that are not selected will be removed to process the quote
        </li>
      </ul>
      `;

      Swal.fire({
        title: 'Error!!',
        html: message,
        showConfirmButton: true,
        allowOutsideClick: false,
        showDenyButton: true,
        customClass: {
                      popup: 'multi_files_error'
                    },
        showCancelButton: true,
        confirmButtonText: 'Proceed',
        denyButtonText:'Upload New Files',
        cancelButtonText: 'Cancel',
        didOpen: (modal) => {
          // Attach plain DOM listeners (not Angular syntax)
          const radios = modal.querySelectorAll<HTMLInputElement>('input[name="multiFileErrors"]');
          radios.forEach(radio => {
            radio.addEventListener('change', (e) => {
              selectedKey = (e.target as HTMLInputElement).value;
            });
          });
        },
        preConfirm: () => {
          if (!selectedKey) {
            // Show built-in validation message
            Swal.showValidationMessage('Please select a file to proceed');
            return false;
          }
          return selectedKey;
        }
      }).then((result) => {
        if (result.isConfirmed) {
          const selected = (result.value as string) ?? selectedKey;
          this.selectFileToProceed(selected!);
          console.log('Selected key:', selected);
        } else if (result.isDenied) {
          const input = document.getElementById('checkFileUpload') as HTMLInputElement | null;
          input?.click();
          if (input) input.value = '';
        } else if (result.isDismissed) {
          this.commonService.goBack();
        }
      });
    }

    selectFileToProceed(selectedKey:any){
      this.commonService.loadingShow();
      this.datacheckLevel1 = [1,2];
      this.datacheckLevel2 = [1,2];
      this.datacheckLevel3 = [1]
      this.dataFnCalled = false;
      this.commonService.commonMainObj.unzip_identify = false;
      this.commonService.commonMainObj.validate_layers = false;
      this.commonService.commonMainObj.fabrication_drawing = false;
      this.commonService.commonMainObj.drill_data = false;
      this.commonService.commonMainObj.render_images = false;
      this.commonService.commonMainObj.fabrication_drawing_additional = false;
      this.commonService.commonMainObj.pcb_additional_fast = false;
      this.commonService.commonMainObj.saveMataDataCheck = false;
      this.commonService.commonMainObj.lamination_calculation_check = false;
      let multiFileIssue:any = {};
      multiFileIssue['job_id'] = this.jobId
      multiFileIssue['selected_folder'] = this.commonService.commonMainObj.fileUploadedData.multipleFoldersDetected.folders[selectedKey].path
      this.apiService.multiFileSocketFn(multiFileIssue,this.socket.id).subscribe((response)=>{
        if (!response || !response.job_id || !response.token) {
          throw new Error('Missing job_id or token in response');
        }
        // this.commonService.commonMainObj.fileUploadedData = {};
        this.jobId = response.job_id;
        this.updateTaskStatus('upload', 'complete', 'File uploaded successfully');
        this.connectWebSocket(response.job_id, response.token);
      },error=>{
          this.commonService.loadingHide();
      })
    }
  
  //IST details for multiple ODB++ or GERBER files uploaded and proceeded OFP-3644
  multiFileIstData(issueData:any){
    this.commonService.commonMainObj.multipleODBFilesDataProceedIstDetails ={
      "issueName":issueData['ist_details'].issue,
      "issueDetail":issueData['ist_details'].details,
      "cisMastIssueActionability":{
        "actionable": '0',
        "fyiOnly" : '1'
      },
      "cisMastIssuePricingImpact":{
        "dontKnow": "0",
        "likely":"0",
        "unlikely": "1"
      },
      "cisMastIssueTurntimeImpact":{
        "dontKnow": "0",
        "likely": "0",
        "unlikely": "1"
      }
    }
  } 


  // ngOnDestroy(): void {
  //   // Unsubscribe and disconnect when the component is destroyed
  //   if (this.messageSubscription) {
  //     this.messageSubscription.unsubscribe();
  //   }
  //   this.disconnect();
  // }
}
